// assets/wishlist.js
(() => {
  const KEY = 'shopify_wishlist_v1';
  let wishlist = JSON.parse(localStorage.getItem(KEY) || '[]');

  const drawer = document.getElementById('wishlistDrawer');
  const overlay = document.getElementById('wishlist-overlay');
  const contents = document.getElementById('wishlistContents');
  const headertitle = document.getElementById('wishlist-title');
  const footer = document.getElementById('wishlist__footer');

  /* Helpers */
  function save() {
    localStorage.setItem(KEY, JSON.stringify(wishlist));
    updateBadges();
  }
  function find(id) {
    return wishlist.find(it => +it.id === +id);
  }
  function updateBadges() {
    document.querySelectorAll('.wishlist-count-badge')
      .forEach(el => el.innerText = wishlist.length);
  }
  function setButtonStateForAll() {
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const id = btn.dataset.productId;
      if (find(id)) btn.classList.add('is-saved');
      else btn.classList.remove('is-saved');
    });
    updateBadges();
  }

  function formatMoney(cents) {
    const n = Number(cents) || 0;
    const centsInt = (n >= 1000) ? Math.round(n) : Math.round(n * 100);
    const rupees = (centsInt / 100).toFixed(2);
    return "₹" + rupees;
  }

  function parsePriceFromDisplay(displayStr) {
    if (!displayStr && displayStr !== 0) return 0;
    try {
      const cleaned = String(displayStr).replace(/[, ]+/g, '').replace(/[^\d.]/g, '');
      if (cleaned === '') return 0;
      const value = parseFloat(cleaned);
      return isNaN(value) ? 0 : Math.round(value * 100);
    } catch (e) { return 0; }
  }

  function calculateWishlistTotal() {
    let finalTotal = 0;
    let originalTotal = 0;
    wishlist.forEach(item => {
      let qty = item.qty || 1;
      let priceCents = Number(item.price_cents) || parsePriceFromDisplay(item.price);
      let compareCents = Number(item.compare_cents) || priceCents;
      finalTotal += priceCents * qty;
      originalTotal += compareCents * qty;
    });
    const footerEl = document.getElementById("wishlistFooterTotals");
    if (!footerEl) return;
    const originalEl = footerEl.querySelector(".wishlist-original");
    const finalEl = footerEl.querySelector(".wishlist-final");
    if (originalTotal > finalTotal) {
      originalEl.style.display = "block";
      originalEl.innerText = formatMoney(originalTotal);
    } else {
      originalEl.style.display = "none";
    }
    finalEl.innerText = formatMoney(finalTotal);
  }

  /* Drawer Rendering */
  function renderDrawer() {
    if (!contents) return;
    contents.innerHTML = '';
    if (wishlist.length === 0) {
      if (drawer) drawer.classList.add("wishlist-empty");
      if (headertitle) headertitle.style.display = "none";
      if (footer) footer.style.display = "none";
      const isLoggedIn =
  drawer?.dataset.customerLoggedIn === 'true';

      contents.innerHTML = `
  <div class="wishlist-drawer__warnings">
    <div class="wishlist-empty-wrapper">
      <h4 class="wishlist-empty-title">Your wishlist is empty</h4>

      <button
        class="wishlist-empty-btn"
        onclick="window.location.href='/collections/all'">
        Continue shopping
      </button>

      ${
        !isLoggedIn
          ? `
            <p class="wishlist-empty-account">Have an account?</p>
            <p class="wishlist-empty-login">
              <a href="/account/login" class="link underlined-link">
                Log in
              </a>
              to save your wishlist permanently.
            </p>
          `
          : ``
      }
    </div>
  </div>
`;

      return;
    }
    if (headertitle) headertitle.style.display = "flex";
    if (footer) footer.style.display = "block";
    drawer?.classList.remove("wishlist-empty");

    wishlist.forEach(item => {
      const div = document.createElement('div');
      div.className = 'wishlist-item';
      const isSoldOut = item.available === false;
      div.innerHTML = `
        <div class="wishlist-item__media">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="meta">
          <div class="product-title">
            <div class="product-price">
              <p class="extrabold"><a href="/products/${item.handle}">${item.title}</a></p>
              <div class="">
              <h5 class="wishlist-price bold">${item.price}</h5>
              ${item.variant && item.variant !== 'Default Title' ? `<p class="grey small" style="margin-top: 8px;">${item.variant} gm</p>` : ''}
              </div
            </div>
            
          </div>
          <div class="wishlist-qty ${isSoldOut ? 'qty-disabled' : ''}" data-id="${item.id}">
              <button class="qty-btn minus" data-id="${item.id}" ${isSoldOut ? 'disabled' : ''}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M4.29377 7.99609L11.7148 7.99613" stroke="#303030" stroke-width="1.5" stroke-linecap="round"/></svg>
              </button>
              <span class="qty-number" id="qty-${item.id}">${item.qty || 1}</span>
              <button class="qty-btn plus" data-id="${item.id}" ${isSoldOut ? 'disabled' : ''}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8.00021 11.7101L8.00023 4.28906M4.29297 7.99646L11.714 7.99648" stroke="#303030" stroke-width="1.5" stroke-linecap="round"/></svg>
              </button>
            </div>
          <div class="actionable-buttons">
            <button class="cart-btns move-to-cart ${isSoldOut ? 'sold-out' : ''}" data-id="${item.id}" ${isSoldOut ? 'disabled' : ''}>${isSoldOut ? 'Sold Out' : 'Add to cart'}</button>
            <button class="cart-btns secondary remove-wishlist-item" data-id="${item.id}">Remove from wishlist</button>
          </div>
        </div>`;
      contents.appendChild(div);
    });
    calculateWishlistTotal();
  }

  function openDrawer() {
    drawer?.classList.add('open');
    overlay?.classList.add('active');
    document.body.classList.add('no-scroll');
    renderDrawer();
  }
  function closeDrawer() {
    overlay?.classList.remove('active');
    document.body.classList.remove('no-scroll');
    drawer?.classList.remove('open');
  }

  function removeById(id) {
    wishlist = wishlist.filter(i => +i.id !== +id);
    save();
    renderDrawer();
    setButtonStateForAll();
  }

  /* FIXED ADD TO CART LOGIC */
  async function moveToCart(id) {
    const item = find(id);
    if (!item || !item.available) return;
    try {
      const r = await fetch(`/products/${item.handle}.js`);
      const product = await r.json();
      const variantId = product.variants[0].id;

      // Use update.js to SET the quantity rather than add to it
      // This prevents 1 (cart) + 1 (wishlist) = 2
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [variantId]: item.qty || 1 } })
      });

      removeById(id);
      window.dispatchEvent(new CustomEvent('cart:refresh'));
      showToast('Item moved to cart');
    } catch (err) { console.error(err); }
  }

  document.addEventListener('click', async e => {
    const btn = e.target.closest('.wishlist-btn');
    // --- Replace the 'Add to Wishlist' section in wishlist.js ---
if (btn) {
  const { productId: id, productHandle: handle } = btn.dataset;
  
  if (find(id)) { 
    removeById(id); 
    showToast('Removed from wishlist'); 
  } else {
    const r = await fetch(`/products/${handle}.js`);
    const p = await r.json();

    // NEW LOGIC: Check if there is a variant ID in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const selectedVariantId = urlParams.get('variant');
    
    // Find the selected variant object, or default to the first available one
    let v = p.variants.find(variant => variant.id == selectedVariantId) || 
            p.variants.find(variant => variant.available) || 
            p.variants[0];

    wishlist.push({
      id: p.id, // Keep product ID for removal logic
      variant_id: v.id, // Store the specific variant ID
      title: p.title,
      variant: v.public_title || v.title,
      handle: p.handle,
      image: v.featured_image ? v.featured_image.src : p.images[0],
      price: "₹" + (v.price / 100).toLocaleString('en-IN'),
      price_cents: v.price,
      compare_cents: v.compare_at_price || v.price,
      qty: 1,
      available: v.available
    });

    save();
    setButtonStateForAll();
    showToast('Added to wishlist');
  }
  return;
}

    if (e.target === overlay || e.target.closest('#closeWishlistBtn')) return closeDrawer();
    if (e.target.closest('.remove-wishlist-item')) return removeById(e.target.closest('.remove-wishlist-item').dataset.id);
    if (e.target.closest('.move-to-cart')) return moveToCart(e.target.closest('.move-to-cart').dataset.id);
    if (e.target.closest('.open-wishlist-btn')) return openDrawer();

    const qtyBtn = e.target.closest('.qty-btn');
    if (qtyBtn) {
      const item = find(qtyBtn.dataset.id);
      if (item) {
        if (qtyBtn.classList.contains('plus')) item.qty = (item.qty || 1) + 1;
        else if (item.qty > 1) item.qty -= 1;
        save(); renderDrawer();
      }
      return;
    }

    /* FIXED MOVE ALL LOGIC */
    if (e.target.matches('#moveAllToCartBtn')) {
      const moveBtn = e.target;
      const originalText = moveBtn.innerText;
      moveBtn.innerText = 'Move items to cart';
      const availableItems = wishlist.filter(i => i.available);
      
      try {
        let updates = {};
        for (const item of availableItems) {
          const r = await fetch(`/products/${item.handle}.js`);
          const p = await r.json();
          updates[p.variants[0].id] = item.qty || 1;
        }

        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });

        wishlist = wishlist.filter(i => !i.available);
        save();
        renderDrawer();
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        showToast('All items moved to cart');
      } catch (err) { console.error(err); }
      finally { moveBtn.innerText = originalText; }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateBadges();
    setButtonStateForAll();
  });

  let toast = document.createElement('div');
  toast.id = 'wishlist-toast';
  document.body.appendChild(toast);

  function showToast(message) {
    toast.innerText = message;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 1500);
  }
})();